export interface CountryConfig {
  countryCode: string;
  name: string;
  currencyCode: string;
  flag: string;
  min: number;
  max: number;
  step: number;
}

export const PIN_LIMIT_COUNTRIES: CountryConfig[] = [
  {
    countryCode: 'MY',
    name: 'Malaysia',
    currencyCode: 'MYR',
    flag: '🇲🇾',
    min: 0,
    max: 250,
    step: 50
  },
  {
    countryCode: 'PH',
    name: 'Philippines',
    currencyCode: 'PHP',
    flag: '🇵🇭',
    min: 0,
    max: 5000,
    step: 1000
  },
  {
    countryCode: 'SG',
    name: 'Singapore',
    currencyCode: 'SGD',
    flag: '🇸🇬',
    min: 0,
    max: 100,
    step: 20
  },
  {
    countryCode: 'AU',
    name: 'Australia',
    currencyCode: 'AUD',
    flag: '🇦🇺',
    min: 0,
    max: 100,
    step: 20
  }
];
